var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 10.9993H11M11 10.9993H7.40002M11 10.9993V14.5993M11 10.9993L11 7.39932M20.6 10.9999C20.6 16.3018 16.302 20.5999 11 20.5999C5.69809 20.5999 1.40002 16.3018 1.40002 10.9999C1.40002 5.69797 5.69809 1.3999 11 1.3999C16.302 1.3999 20.6 5.69797 20.6 10.9999Z",
    stroke: "#0037A2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPlusIcon);
export default __webpack_public_path__ + "static/media/admin-plus-icon.f560fa4bd5544f58b78ab5dea48f0dbe.svg";
export { ForwardRef as ReactComponent };